import { render, staticRenderFns } from "./brandDetail.vue?vue&type=template&id=5ec860f1&scoped=true"
import script from "./brandDetail.vue?vue&type=script&lang=ts"
export * from "./brandDetail.vue?vue&type=script&lang=ts"
import style0 from "./brandDetail.vue?vue&type=style&index=0&id=5ec860f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec860f1",
  null
  
)

export default component.exports